var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgDesignTool = function SvgDesignTool(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#design-tool_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.21 1.79.687 15.313M10.552 10.771l-2.33-.332",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.547 8.775-2.328-.332",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49 7.187a2.825 2.825 0 0 0-.82 2.184l.248 3.712 3.711.248a2.826 2.826 0 0 0 2.184-.82l5.396-5.396a3.765 3.765 0 1 0-5.323-5.322L3.49 7.187Z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "design-tool_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDesignTool);
export default ForwardRef;